// import { Link } from "react-router-dom";
import { useState } from "react";

// COMPONENTS //
import BrushButton from "../../components/BrushButton";
import Borders from "../../components/Borders";

// IMAGES //
import borderPage from "../../assets/border_page.png";

import "./about.css";

export default function About({ startMusic }) {
    const [slideIndex, setSlideIndex] = useState(0);

    const slides = [
        "about",
        "credits",
        "support"
    ];

    const isFirstSlide = slideIndex === 0;
    const isLastSlide = slideIndex === slides.length - 1;

    function goPrevious() {
        setSlideIndex((currentIndex) => Math.max(currentIndex - 1, 0));
    }

    function goNext() {
        setSlideIndex((currentIndex) =>
            Math.min(currentIndex + 1, slides.length - 1)
        );
    }

    return (
        <div className="game-page about-page">
            <Borders image={borderPage} scale={0.98} />
            
            <h1 className="game-title">About I Morti di Valpolicella</h1>

            <div className="about-viewport">
                <div
                    className="about-track"
                    style={{ transform: `translateX(-${slideIndex * 100}%)` }}
                >
                    <section className="about-slide">
                        <div className="about-copy">
                            <p><em>I Morti di Valpolicella</em> began as my final project for a software engineering bootcamp. The assignment required students to use a database, implement user authentication, demonstrate CRUD functionality, and build the interface using a CSS framework (which I've since scrapped). Rather than create another business application, I decided to make a game.</p>

                            <p>The setting was inspired by Valpolicella, the beautiful wine-producing region in northern Italy that's home to my favorite wine: Amarone. The villages, art, food, and history felt like the perfect backdrop for a zombie apocalypse.</p>

                            <p>This version is a small narrative experiment, but my goal is to transform it into a side-scrolling action game complete with exploration, combat, and considerably more zombie-related splatter. You'll begin among the vineyards of San Giorgio before making your way through Negrar and Parona on the road to Verona, Romeo and Juliet's old stomping grounds. Hopefully, you'll have made enough zombie friends along the way to help you take the big city!</p>

                            <p>Until then, please enjoy this humble prologue: a resurrected student project with its best chapters still ahead.</p>
                        </div>
                    </section>

                    <section className="about-slide">
                        <div className="credits-copy">
                            <dl className="credits-list">
                                <div>
                                    <dt>Created By</dt>
                                    <dd>David Milton</dd>
                                </div>

                                <div>
                                    <dt>Programming, Story, Illustration & Visual Design</dt>
                                    <dd>David Milton</dd>
                                </div>

                                <div>
                                    <dt>Music</dt>
                                    <dd>"Dreamland" by Humans Win</dd>
                                </div>
                            </dl>
                        </div>
                    </section>

                    <section className="about-slide">
                        <div className="support-copy">
                            <p>If you'd like to follow the project, support future development, or see more of my work, you can find me here:</p>

                            <div className="support-links">
                                <a href="https://aplanetaryshift.com" target="_blank" rel="noopener noreferrer">
                                    A Planetary Shift
                                </a>

                                <a href="https://instagram.com/aplanetaryshift" target="_blank" rel="noopener noreferrer">
                                    Instagram
                                </a>

                                <a href="https://patreon.com/aplanetaryshift" target="_blank" rel="noopener noreferrer">
                                    Patreon
                                </a>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <div className="about-actions">
                <BrushButton
                    // className="about-nav-button"
                    className={`about-nav-button ${isFirstSlide ? "hidden-nav" : ""}`}
                    onClick={goPrevious}
                    disabled={isFirstSlide}
                >
                    ←
                </BrushButton>

                <BrushButton className="about-button" to="/">
                    Back to Title
                </BrushButton>

                {/* <span className="about-slide-counter">
                    {slideIndex + 1} / {slides.length}
                </span> */}

                {/* <BrushButton
                    className="about-button"
                    to="/createzombie"
                    onClick={startMusic}
                >
                    Play Prologue
                </BrushButton> */}

                <BrushButton
                    // className="about-nav-button"
                    className={`about-nav-button ${isLastSlide ? "hidden-nav" : ""}`}
                    onClick={goNext}
                    disabled={isLastSlide}
                >
                    →
                </BrushButton>
            </div>
        </div>
    );
}